// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-74c9c345] .el-dialog__body{overflow:auto!important}[data-v-74c9c345] .el-input-number .el-input__inner{text-align:left!important}", ""]);
// Exports
module.exports = exports;
